'use strict';

var _typeof = require("/home/guisjlender/ubuntu-development/workspace/mobicare/mcare-artemis-sdk/node_modules/@babel/runtime/helpers/typeof");

module.exports = function numberify(value) {
  if (!/string|number|boolean/.test(_typeof(value))) {
    return undefined;
  }

  return isNaN(value) ? undefined : Number(value);
};